module.exports = __webpack_public_path__ + "static/media/worth_a_read_top_navbar_icon.2110d8df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/worth_a_read_top_navbar_icon.svg
// module id = 442
// module chunks = 1